// Function to Generate a Random 6-Digit ID
const generateId = () => Math.floor(100000 + Math.random() * 900000).toString();

// ✅ Class Data (For Class Table & Card View)
export const classData = [
  {
    id: generateId(),
    className: "HIIT Training",
    timing: "10:00 AM - 11:00 AM",
    price: 25,
    description: "High-intensity interval training class for a full-body workout.",
    classType: "Recurring",
    status: "Active",
    date: "2024-03-15",
    image: "https://picsum.photos/200/300?random=1",
  },
  {
    id: generateId(),
    className: "Yoga for Beginners",
    timing: "8:00 AM - 9:00 AM",
    price: 15,
    description: "Relaxing yoga session to improve flexibility and posture.",
    classType: "One-Time",
    status: "Active",
    date: "2024-03-16",
    image: "https://picsum.photos/200/300?random=2",
  },
  {
    id: generateId(),
    className: "Strength Training",
    timing: "5:30 PM - 6:30 PM",
    price: 30,
    description: "Strength-building exercises with expert trainers.",
    classType: "Recurring",
    status: "Inactive",
    date: "2024-03-17",
    image: "https://picsum.photos/200/300?random=3",
  },
  {
    id: generateId(),
    className: "Zumba Dance",
    timing: "6:00 PM - 7:00 PM",
    price: 20,
    description: "Fun and energetic Zumba dance session to burn calories.",
    classType: "One-Time",
    status: "Active",
    date: "2024-03-18",
    image: "https://picsum.photos/200/300?random=4",
  },
  {
    id: generateId(),
    className: "Pilates Core Workout",
    timing: "7:30 AM - 8:30 AM",
    price: 22,
    description: "Pilates class focused on core strength and endurance.",
    classType: "Recurring",
    status: "Active",
    date: "2024-03-19",
    image: "https://picsum.photos/200/300?random=5",
  },
];

// ✅ Booking Data (For View Bookings Section)
export const bookingData = [
  {
    id: generateId(),
    studentName: "John Doe",
    className: "HIIT Training",
    date: "2024-03-15",
    status: "Confirmed",
    paymentStatus: "Paid",
  },
  {
    id: generateId(),
    studentName: "Jane Smith",
    className: "Yoga for Beginners",
    date: "2024-03-16",
    status: "Pending",
    paymentStatus: "Unpaid",
  },
  {
    id: generateId(),
    studentName: "Mike Johnson",
    className: "Strength Training",
    date: "2024-03-17",
    status: "Confirmed",
    paymentStatus: "Paid",
  },
  {
    id: generateId(),
    studentName: "Emily Brown",
    className: "Zumba Dance",
    date: "2024-03-18",
    status: "Confirmed",
    paymentStatus: "Paid",
  },
  {
    id: generateId(),
    studentName: "David Wilson",
    className: "Pilates Core Workout",
    date: "2024-03-19",
    status: "Pending",
    paymentStatus: "Unpaid",
  },
  {
    id: generateId(),
    studentName: "Sophia Lee",
    className: "HIIT Training",
    date: "2024-03-15",
    status: "Confirmed",
    paymentStatus: "Paid",
  },
];
